import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Target, TrendingUp, Sparkles, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { DjayAvatar, useDjaySelection } from '../mascot';
interface SprintIntroProps {
  isOpen: boolean;
  onStart: () => void;
  onCancel: () => void;
}
export function SprintIntro({
  isOpen,
  onStart,
  onCancel
}: SprintIntroProps) {
  const {
    selectedVariant
  } = useDjaySelection();
  return <AnimatePresence data-id="element-2885">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-2886">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={onCancel} data-id="element-2887" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-2888">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-6 text-white text-center relative" data-id="element-2889">
              <button onClick={onCancel} className="absolute top-4 right-4 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors" data-id="element-2890">
                <X className="w-5 h-5" data-id="element-2891" />
              </button>
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3 backdrop-blur-md" data-id="element-2892">
                <Target className="w-8 h-8 text-white" data-id="element-2893" />
              </div>
              <h2 className="text-2xl font-black tracking-tight" data-id="element-2894">
                Gerichte Training
              </h2>
            </div>

            {/* Content */}
            <div className="p-6 sm:p-8" data-id="element-2895">
              <div className="flex gap-4 items-start mb-6" data-id="element-2896">
                <div className="flex-shrink-0 mt-1" data-id="element-2897">
                  <DjayAvatar size="md" emotion="excited" variant={selectedVariant} animate={true} data-id="element-2898" />
                </div>
                <div className="bg-blue-50 rounded-2xl rounded-tl-none p-4 border border-blue-100 text-blue-900 text-sm font-medium leading-relaxed" data-id="element-2899">
                  Hoi! Bij Gerichte Training oefen je één onderwerp. Je krijgt
                  vragen van makkelijk naar moeilijk — zo word je steeds beter!
                </div>
              </div>

              <div className="space-y-4 mb-8" data-id="element-2900">
                <div className="flex items-start gap-3" data-id="element-2901">
                  <div className="mt-0.5 bg-blue-100 p-1 rounded-full text-blue-600" data-id="element-2902">
                    <Target className="w-4 h-4" data-id="element-2903" />
                  </div>
                  <div data-id="element-2904">
                    <p className="text-sm font-bold text-slate-800" data-id="element-2905">
                      Eén onderwerp
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-2906">
                      Je focust op één ding tegelijk. Dat werkt het beste!
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-2907">
                  <div className="mt-0.5 bg-emerald-100 p-1 rounded-full text-emerald-600" data-id="element-2908">
                    <TrendingUp className="w-4 h-4" data-id="element-2909" />
                  </div>
                  <div data-id="element-2910">
                    <p className="text-sm font-bold text-slate-800" data-id="element-2911">
                      Van makkelijk naar moeilijk
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-2912">
                      Je begint makkelijk en het wordt steeds uitdagender.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-2913">
                  <div className="mt-0.5 bg-amber-100 p-1 rounded-full text-amber-600" data-id="element-2914">
                    <Sparkles className="w-4 h-4" data-id="element-2915" />
                  </div>
                  <div data-id="element-2916">
                    <p className="text-sm font-bold text-slate-800" data-id="element-2917">
                      10 gerichte vragen
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-2918">
                      Na 10 vragen zie je hoeveel je bent gegroeid.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-3" data-id="element-2919">
                <Button variant="secondary" onClick={onCancel} className="flex-1" data-id="element-2920">
                  Niet nu
                </Button>
                <Button variant="primary" onClick={onStart} className="flex-1 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 border-none shadow-lg shadow-blue-200" data-id="element-2921">
                  Start!
                </Button>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}